var map = {
	"./ContactView.vue": [
		5395,
		373,
		63,
		555
	],
	"./ContentView.vue": [
		8567,
		373,
		63,
		823
	],
	"./GameDetailView.vue": [
		7749,
		373,
		63,
		497
	],
	"./GameView.vue": [
		6838,
		373,
		63,
		485
	],
	"./IslamyatView.vue": [
		8425,
		373,
		63,
		389
	],
	"./KidsView.vue": [
		1499,
		373,
		63,
		227
	],
	"./KitchenView.vue": [
		2827,
		373,
		63,
		803
	],
	"./NotFoundView.vue": [
		3991,
		722
	],
	"./PlayView.vue": [
		229,
		229
	],
	"./SearchView.vue": [
		5018,
		373,
		63,
		156
	],
	"./SoundView.vue": [
		6249,
		373,
		63,
		866
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8235;
module.exports = webpackAsyncContext;